const SettingsIcons = {
    copy: (
        <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1">
            <g id="surface1">
                <path
                    style={{
                        fill: 'none',
                        strokeWidth: 2,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        stroke: 'rgb(18.039216%,38.431373%,100%)',
                        strokeOpacity: 1,
                        strokeMiterlimit: 4
                    }}
                    d="M 47 17 L 47 23 C 47 24.107143 47.892857 25 49 25 L 55 25 L 47 17 L 41 17 L 41 46 C 41 47.107143 40.107143 48 39 48 L 11 48 C 9.892857 48 9 47.107143 9 46 L 9 7 C 9 5.892857 9.892857 5 11 5 L 33 5 L 41 13 L 35 13 C 33.892857 13 33 12.107143 33 11 L 33 5 "
                    transform="matrix(0.21875,0,0,0.21875,0,0)"
                />
                <path
                    style={{
                        fill: 'none',
                        strokeWidth: 2,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        stroke: 'rgb(18.039216%,38.431373%,100%)',
                        strokeOpacity: 1,
                        strokeMiterlimit: 4
                    }}
                    d="M 55 29 L 55 57 C 55 58.107143 54.107143 59 53 59 L 25 59 C 23.892857 59 23 58.107143 23 57 L 23 48 "
                    transform="matrix(0.21875,0,0,0.21875,0,0)"
                />
            </g>
        </svg>
    ),
    paste: (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
            <g id="surface1">
                <path
                    style={{
                        fill: 'none',
                        strokeWidth: 5,
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        stroke: 'rgb(18.039216%,38.431373%,100%)',
                        strokeOpacity: 1,
                        strokeMiterlimit: 4
                    }}
                    d="M 68 63 C 68 58.03125 72.03125 54 77 54 L 91.125 54 C 93 54 94.78125 54.75 96.09375 56.03125 L 100.9375 60.875 L 102.15625 62.21875 C 103.34375 63.53125 104 65.21875 104 66.96875 L 104 93 C 104 97.96875 99.96875 102 95 102 L 77 102 C 72.03125 102 68 97.96875 68 93 Z M 68 63 "
                    transform="matrix(0.125,0,0,0.125,0,0)"
                />
                <path
                    style={{
                        fill: 'none',
                        strokeWidth: 5,
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        stroke: 'rgb(18.039216%,38.431373%,100%)',
                        strokeOpacity: 1,
                        strokeMiterlimit: 4
                    }}
                    d="M 91 54 L 91 35 C 91 30.03125 86.96875 26 82 26 L 42 26 C 37.03125 26 33 30.03125 33 35 L 33 93 C 33 97.96875 37.03125 102 42 102 L 80 102 M 91 55 L 91 65 C 91 66.65625 92.34375 68 94 68 L 104 68 "
                    transform="matrix(0.125,0,0,0.125,0,0)"
                />
                <path
                    style={{
                        fill: 'none',
                        strokeWidth: 5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'miter',
                        stroke: 'rgb(18.039216%,38.431373%,100%)',
                        strokeOpacity: 1,
                        strokeMiterlimit: 4
                    }}
                    d="M 50 34 C 51.1875 34 66.15625 34 73.5 34 "
                    transform="matrix(0.125,0,0,0.125,0,0)"
                />
            </g>
        </svg>
    )
};

export default SettingsIcons;
